import App from './layout/Layout';
import Vue from 'vue';
import router from './routes/router';
import './brand/global.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
